/* BD-OFFERS-0925 · cart progress bar motion, free-cap gift engine, BD95 code block, BOGO buy blocks.
   The discounts themselves are Shopify automatic discounts (BOGO, free cap over $300, free NZ shipping
   over $110) + code BD95; this file only drives the storefront. Handlers are delegated on document
   because Prestige replaces the drawer/cart markup on every re-render. */
(function () {
  'use strict';
  var CFG = window.BD_OFFERS || {};
  var GIFT_VARIANT = CFG.giftVariant ? Number(CFG.giftVariant) : 0;
  var GIFT_AT = CFG.giftAt || 30000;
  var GIFT_PROP = '_bd_gift';
  var reduced = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  var ss = {
    get: function (k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} },
    del: function (k) { try { sessionStorage.removeItem(k); } catch (e) {} }
  };
  function post(url, body) {
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) { var e = new Error(d.description || d.message || 'Request failed'); e.data = d; throw e; } return d; }); });
  }
  function getCart() { return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
  function refreshCart() { document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); }

  /* =========================== progress bar motion =========================== */
  function drawerOpen() { var d = document.getElementById('sidebar-cart'); return d && d.getAttribute('aria-hidden') === 'false'; }
  function playRace() {
    var bar = document.querySelector('#sidebar-cart [data-bd-race]');
    if (!bar || bar._bdPlayed) return;
    if (!drawerOpen()) { bar._bdPending = true; return; }
    bar._bdPlayed = true;
    var track = bar.querySelector('.BDRace__Track');
    var to = parseFloat(bar.getAttribute('data-pct')) || 0;
    var from = parseFloat(ss.get('bdRacePct'));
    if (isNaN(from)) from = 0;
    var flags = (bar.getAttribute('data-ship') ? 's' : '') + (bar.getAttribute('data-gift') ? 'g' : '');
    var prev = ss.get('bdRaceFlags') || '';
    ss.set('bdRacePct', String(to)); ss.set('bdRaceFlags', flags);
    if (reduced || from === to) return;
    track.style.setProperty('--bd-race-pct', from + '%');
    track.getBoundingClientRect();
    setTimeout(function () {
      track.style.setProperty('--bd-race-pct', to + '%');
      [['s', 'ship'], ['g', 'gift']].forEach(function (p) {
        if (flags.indexOf(p[0]) > -1 && prev.indexOf(p[0]) < 0) {
          var stop = bar.querySelector('[data-stop="' + p[1] + '"]');
          if (stop) setTimeout(function () { stop.classList.add('is-pop'); }, 650);
        }
      });
    }, 40);
  }

  /* =============================== gift engine =============================== */
  var giftBusy = false, giftAgain = false, giftActions = [];
  function giftLines(cart) { return cart.items.filter(function (i) { return i.properties && i.properties[GIFT_PROP]; }); }
  function giftBase(cart, lines) { return cart.total_price - lines.reduce(function (a, i) { return a + i.final_line_price; }, 0); }
  function throttled() {
    var now = Date.now(); giftActions = giftActions.filter(function (t) { return now - t < 60000; });
    if (giftActions.length >= 6) return true; giftActions.push(now); return false;
  }
  function addGift() {
    return post('/cart/add.js', { items: [{ id: GIFT_VARIANT, quantity: 1, properties: { _bd_gift: 'cap-300' } }] });
  }
  function syncGift() {
    if (!GIFT_VARIANT) return;
    if (giftBusy) { giftAgain = true; return; }
    giftBusy = true;
    getCart().then(function (cart) {
      var lines = giftLines(cart), key = 'bdGift:' + (cart.token || ''), state = ss.get(key);
      if (!cart.item_count) { ss.del(key); return null; }                 /* emptied cart = fresh start */
      var eligible = giftBase(cart, lines) >= GIFT_AT;
      var job = null;
      if (eligible && !lines.length) {
        if (state === 'added') ss.set(key, 'declined');          /* shopper removed it: respect that */
        else if (state !== 'declined' && !throttled()) job = addGift().then(function () { ss.set(key, 'added'); });
      } else if (eligible && (lines.length > 1 || lines[0].quantity > 1) && !throttled()) {
        job = post('/cart/change.js', { id: lines[0].key, quantity: 1 }).then(function () {
          return lines.slice(1).reduce(function (p, l) { return p.then(function () { return post('/cart/change.js', { id: l.key, quantity: 0 }); }); }, Promise.resolve());
        });
      } else if (!eligible && lines.length && !throttled()) {
        job = lines.reduce(function (p, l) { return p.then(function () { return post('/cart/change.js', { id: l.key, quantity: 0 }); }); }, Promise.resolve())
          .then(function () { if (ss.get(key) === 'added') ss.del(key); });
      }
      return job && job.then(refreshCart);
    }).catch(function () {}).then(function () {
      giftBusy = false;
      if (giftAgain) { giftAgain = false; setTimeout(syncGift, 60); }
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bd-gift-claim]'); if (!btn || !GIFT_VARIANT) return;
    btn.disabled = true; btn.textContent = 'Adding…';
    getCart().then(function (cart) { ss.set('bdGift:' + (cart.token || ''), 'added'); return addGift(); })
      .then(refreshCart).catch(function () { btn.disabled = false; btn.textContent = 'Add it to your cart'; });
  });

  /* ============================== BD95 code block ============================== */
  var codeMsg = null;
  function paintCodeMsg() {
    if (!codeMsg || Date.now() - codeMsg.t > 8000) return;
    document.querySelectorAll('[data-bd95-msg]').forEach(function (m) {
      var cls = 'BDCode__Msg is-' + codeMsg.kind;
      if (m.className !== cls) m.className = cls;
      if (m.textContent !== codeMsg.text) m.textContent = codeMsg.text;
    });
  }
  function setCode(code, btn) {
    if (btn) { btn.disabled = true; btn.setAttribute('data-label', btn.textContent); btn.textContent = code ? 'Applying…' : 'Removing…'; }
    document.dispatchEvent(new CustomEvent('theme:loading:start'));
    post('/cart/update.js', { discount: code }).then(function (cart) {
      if (!code) { codeMsg = { kind: 'ok', text: 'Code removed.', t: Date.now() }; return; }
      var ok = (cart.discount_codes || []).some(function (c) { return c.applicable && c.code.toUpperCase() === code.toUpperCase(); });
      if (ok) { codeMsg = { kind: 'ok', text: code + ' applied. It carries through to checkout.', t: Date.now() }; return; }
      codeMsg = { kind: 'err', text: code === 'BD95' ? 'BD95 could not be applied to this cart.' : '“' + code + '” isn’t valid for this cart. Check the spelling and try again.', t: Date.now() };
      return post('/cart/update.js', { discount: '' });
    }).catch(function () {
      codeMsg = { kind: 'err', text: 'The code couldn’t be updated. Please try again.', t: Date.now() };
    }).then(function () {
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      if (btn && btn.isConnected) { btn.disabled = false; btn.textContent = btn.getAttribute('data-label'); }
      refreshCart(); paintCodeMsg();
    });
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    var ap = t.closest('[data-bd95-apply]'); if (ap) { setCode(ap.getAttribute('data-bd95-apply'), ap); return; }
    var api = t.closest('[data-bd95-apply-input]');
    if (api) {
      var input = api.closest('[data-bd95]').querySelector('[data-bd95-input]'), v = (input.value || '').trim().toUpperCase();
      if (!v) { input.focus(); return; }
      setCode(v, api); return;
    }
    var rm = t.closest('[data-bd95-remove]'); if (rm) setCode('', rm);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !e.target.matches || !e.target.matches('[data-bd95-input]')) return;
    e.preventDefault(); var b = e.target.closest('[data-bd95]').querySelector('[data-bd95-apply-input]'); if (b) b.click();
  });

  /* ============================== BOGO buy blocks ============================== */
  /* BD-PICK-0925: tier 2 = two slots (any merch item each), chosen in a Comfort-Culture-style quick-add sheet.
     Page 1 = item grid, page 2 = size. Both pages share one grid cell, so switching never changes height. */
  function money(c) { return '$' + (c / 100).toFixed(2).replace(/\.00$/, ''); }
  function readJSON(el) { try { return JSON.parse(el.textContent); } catch (e) { return null; } }
  function bogoTier(box) { var r = box.querySelector('[data-bd-bogo-tier]:checked'); return r ? Number(r.value) : 1; }
  function merchOf(box) {
    if (!box._merch) { var list = readJSON(box.querySelector('[data-bd-merch]')) || []; box._merch = {}; list.forEach(function (p) { box._merch[p.id] = p; }); box._merchList = list; }
    return box._merch;
  }
  function slotState(box) {
    if (!box._slots) box._slots = Array.prototype.map.call(box.querySelectorAll('[data-bd-slot]'), function (s) {
      return { pid: Number(s.getAttribute('data-bd-slot-product')), vid: Number(s.getAttribute('data-bd-slot-variant')) };
    });
    return box._slots;
  }
  function variantOf(p, vid) { return p && p.variants.filter(function (v) { return v.id === vid; })[0]; }
  /* BD-STOCK-0926: q = live inventory (null when Shopify doesn't track the variant). Low = 1..3 left. */
  var LOW_AT = 3;
  function lowLeft(v) { return v && v.q != null && v.q > 0 && v.q <= LOW_AT ? v.q : 0; }
  function leftText(n) { return 'Low stock, only ' + n + ' left'; }
  function pairPrices(box) {
    var M = merchOf(box), prices = slotState(box).map(function (s) { var v = variantOf(M[s.pid], s.vid); return v ? v.price : 0; });
    var hi = Math.max.apply(null, prices), lo = Math.min.apply(null, prices);
    return { pay: hi, was: hi + lo, save: lo };
  }
  /* BD-PICK-0925b: the BXGY frees the CHEAPER item, so the FREE label sits on the cheaper slot (a tie = Item 2). */
  function freeIdx(box) {
    var M = merchOf(box), pr = slotState(box).map(function (s) { var v = variantOf(M[s.pid], s.vid); return v ? v.price : 0; });
    return pr[0] < pr[1] ? 0 : 1;
  }
  var ICON_CHEV = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9.5l6 6 6-6"/></svg>';
  function paintSlot(box, i, animate) {
    var s = slotState(box)[i], p = merchOf(box)[s.pid], v = variantOf(p, s.vid), el = box.querySelector('[data-bd-slot="' + i + '"]');
    if (!p || !v || !el) return;
    if (sz.open && el.contains(sz.open)) sizeClose(false);   /* the meta is rebuilt below; never leave a detached menu open */
    var free = freeIdx(box) === i;
    var priceHtml = free
      ? '<span class="BDFree BDSlot__Free">FREE</span><s class="BDSlot__Was">' + money(v.price) + '</s>'
      : '<span class="BDSlot__Price">' + money(v.price) + '</span>';
    var sizeHtml = '';
    if (p.sized) {
      sizeHtml = '<span class="BDSlot__SizeWrap"><button type="button" class="BDSlot__Size" data-bd-size-btn aria-haspopup="listbox" aria-expanded="false" aria-label="' + esc(p.opt) + ' ' + esc(v.title) + '. Change ' + esc(p.opt.toLowerCase()) + '">' + esc(p.opt) + ' <b>' + esc(v.title) + '</b>' + ICON_CHEV + '</button>' +
        '<div class="BDSize" data-bd-size-menu role="listbox" aria-label="' + esc(p.opt) + '" hidden>' +
        p.variants.map(function (o) {
          return '<button type="button" role="option" class="BDSize__Opt" data-bd-size-vid="' + o.id + '" aria-selected="' + (o.id === v.id) + '"' + (o.available ? (lowLeft(o) ? ' aria-label="' + esc(o.title) + ', only ' + lowLeft(o) + ' left"' : '') : ' disabled aria-label="' + esc(o.title) + ' sold out"') + '>' + esc(o.title) + (o.available && lowLeft(o) ? '<small class="BDSize__Left"><span aria-hidden="true" style="color:#c9c9c9;margin-right:4px">·</span>' + lowLeft(o) + ' left</small>' : '') + '</button>';
        }).join('') + '</div></span><span class="BDSlot__Sep" aria-hidden="true">·</span>';
    }
    el.querySelector('[data-bd-slot-title]').textContent = p.title;
    var low = lowLeft(v);
    el.querySelector('[data-bd-slot-meta]').innerHTML = sizeHtml + priceHtml + (low ? '<span class="BDSlot__Low"><span class="BDStock__Dot" aria-hidden="true"></span>Only ' + low + ' left</span>' : '');
    var img = el.querySelector('[data-bd-slot-img]'); if (img && p.img && img.getAttribute('src') !== p.img) img.src = p.img;
    var open = el.querySelector('[data-bd-slot-open]');
    if (open) open.setAttribute('aria-label', 'Item ' + (i + 1) + ': ' + p.title + (p.sized ? ', ' + p.opt + ' ' + v.title : '') + (free ? ', free' : ', ' + money(v.price)) + '. Change item');
    if (animate && !reduced) { el.classList.remove('is-updated'); el.getBoundingClientRect(); el.classList.add('is-updated'); }
  }
  /* size menu on the slot pill (currency-switcher style): one open at a time, reflow-then-class, Escape/arrows/outside click */
  var sz = { open: null };
  function sizeOpen(wrap) {
    if (sz.open === wrap) return;
    sizeClose(false);
    var menu = wrap.querySelector('[data-bd-size-menu]'), btn = wrap.querySelector('[data-bd-size-btn]'), slot = wrap.closest('.BDSlot');
    clearTimeout(wrap._bdT);
    menu.hidden = false; slot.classList.add('is-menu-open');
    menu.getBoundingClientRect();
    menu.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true');
    sz.open = wrap;
    var sel = menu.querySelector('[aria-selected="true"]:not(:disabled)') || menu.querySelector('[data-bd-size-vid]:not(:disabled)');
    if (sel) sel.focus({ preventScroll: true });
  }
  function sizeClose(focusBtn) {
    var wrap = sz.open; if (!wrap) return;
    sz.open = null;
    var menu = wrap.querySelector('[data-bd-size-menu]'), btn = wrap.querySelector('[data-bd-size-btn]'), slot = wrap.closest('.BDSlot');
    if (menu) menu.classList.remove('is-open');
    if (btn) { btn.setAttribute('aria-expanded', 'false'); if (focusBtn) btn.focus({ preventScroll: true }); }
    wrap._bdT = setTimeout(function () { if (menu) menu.hidden = true; if (slot) slot.classList.remove('is-menu-open'); }, reduced ? 0 : 200);
  }
  function paintPair(box) {
    var pp = pairPrices(box);
    paintSlot(box, 0, false); paintSlot(box, 1, false);   /* FREE label follows the cheaper slot as picks change */
    var price = box.querySelector('[data-bd-pair-price]'), was = box.querySelector('[data-bd-pair-was]'), save = box.querySelector('[data-bd-pair-save]');
    if (price) price.textContent = money(pp.pay);
    if (was) was.textContent = money(pp.was);
    if (save) save.textContent = 'Save ' + money(pp.save);
    return pp;
  }
  function bogoPaint(box) {
    var form = box.closest('form'), tier = bogoTier(box);
    box.querySelectorAll('.BDBogo__Tier').forEach(function (a) { a.classList.toggle('is-selected', Number(a.getAttribute('data-tier')) === tier); });
    if (!form) return;
    form.classList.toggle('bd-bogo-pair', tier === 2);
    var pp = paintPair(box);
    var btn = form.querySelector('.ProductForm__AddToCart');
    if (btn && !btn.disabled) {
      var spans = btn.querySelectorAll(':scope > span');
      if (spans[0]) { if (!spans[0].hasAttribute('data-bd-label')) spans[0].setAttribute('data-bd-label', spans[0].textContent); spans[0].textContent = tier === 2 ? 'Add 2 to cart' : spans[0].getAttribute('data-bd-label'); }
      var unit = Number(box.getAttribute('data-unit'));
      if (spans.length > 2) spans[spans.length - 1].textContent = money(tier === 2 ? pp.pay : unit);
    }
    /* keep the native id field on "Just one"'s size so Buy it now buys the right variant */
    var pick = box.querySelector('.BDBogo__Tier[data-tier="1"] [data-bd-pick]'), idField = form.querySelector('[name="id"]');
    if (idField) idField.value = pick ? pick.value : box.getAttribute('data-default');
    paintStock(box, tier, pick);
  }
  function paintStock(box, tier, pick) {
    var line = box.querySelector('[data-bd-stock]'); if (!line) return;
    if (!box._vars) box._vars = readJSON(box.querySelector('[data-bd-bogo-variants]')) || [];
    var vid = Number(pick ? pick.value : box.getAttribute('data-default'));
    var v = box._vars.filter(function (x) { return x.id === vid; })[0], n = tier === 1 ? lowLeft(v) : 0;
    line.hidden = !n;                             /* pair tier: each slot carries its own note */
    if (n) line.querySelector('[data-bd-stock-text]').textContent = leftText(n);
  }
  function bogoItems(box) {
    var ids = [];
    if (bogoTier(box) === 2) ids = slotState(box).map(function (s) { return s.vid; });
    else { var pick = box.querySelector('.BDBogo__Tier[data-tier="1"] [data-bd-pick]'); ids = [Number(pick ? pick.value : box.getAttribute('data-default'))]; }
    var merged = {}; ids.forEach(function (id) { merged[id] = (merged[id] || 0) + 1; });
    return Object.keys(merged).map(function (id) { return { id: Number(id), quantity: merged[id] }; });
  }
  function bogoInit(root) {
    (root || document).querySelectorAll('[data-bd-bogo]').forEach(function (box) {
      if (box._bdInit) return; box._bdInit = true;
      /* warm the sheet's product images once the page is idle, so the first open paints instantly */
      setTimeout(function () { merchOf(box); (box._merchList || []).forEach(function (p) { if (p.img) { var im = new Image(); im.decoding = 'async'; im.src = p.img; } }); }, 1200);
      var form = box.closest('form'); if (form) form.classList.add('bd-has-bogo');
      bogoPaint(box);
    });
  }
  document.addEventListener('change', function (e) {
    var box = e.target.closest && e.target.closest('[data-bd-bogo]'); if (box) bogoPaint(box);
  });

  /* ---------------- quick-add sheet ---------------- */
  var ICON_X = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var ICON_BACK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14.5 6l-6 6 6 6"/></svg>';
  var ICON_TICK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  var pk = { root: null, box: null, slot: 0, pid: 0, vid: 0, trigger: null, page: 1, closing: 0 };
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function pickRoot() {
    if (pk.root) return pk.root;
    var d = document.createElement('div');
    d.className = 'BDPick'; d.hidden = true;
    d.innerHTML =
      '<div class="BDPick__Scrim" data-bd-pick-close></div>' +
      '<section class="BDPick__Panel" role="dialog" aria-modal="true" aria-labelledby="BDPickTitle">' +
        '<div class="BDPick__Grip" aria-hidden="true"></div>' +
        '<header class="BDPick__Head">' +
          '<button type="button" class="BDPick__Icon BDPick__Back" data-bd-pick-back aria-label="Back to all items">' + ICON_BACK + '</button>' +
          '<div class="BDPick__Heading"><h2 id="BDPickTitle" class="BDPick__Title Heading"></h2><p class="BDPick__Sub" data-bd-pick-sub></p></div>' +
          '<button type="button" class="BDPick__Icon BDPick__Close" data-bd-pick-close aria-label="Close">' + ICON_X + '</button>' +
        '</header>' +
        '<div class="BDPick__Stage" data-page="1">' +
          '<div class="BDPick__Page BDPick__Page--grid" data-bd-page="1"><div class="BDPick__Grid" data-bd-pick-grid></div></div>' +
          '<div class="BDPick__Page BDPick__Page--size" data-bd-page="2" inert>' +
            '<div class="BDPick__Detail"><span class="BDPick__DetailMedia"><img data-bd-pick-dimg alt=""></span>' +
            '<div><strong data-bd-pick-dtitle></strong><span data-bd-pick-dprice></span></div></div>' +
            '<fieldset class="BDPick__Sizes"><legend data-bd-pick-dlegend>Size</legend><div class="BDPick__Pills" data-bd-pick-pills></div></fieldset>' +
            '<button type="button" class="BDPick__Confirm" data-bd-pick-confirm disabled>Choose a size</button>' +
          '</div>' +
        '</div>' +
      '</section>';
    document.body.appendChild(d);
    pk.root = d;
    return d;
  }
  function renderGrid() {
    var box = pk.box, list = box._merchList || [], cur = slotState(box)[pk.slot];
    pk.root.querySelector('[data-bd-pick-grid]').innerHTML = list.map(function (p, i) {
      var avail = p.variants.some(function (v) { return v.available; }), sel = p.id === cur.pid;
      var price = Math.min.apply(null, p.variants.map(function (v) { return v.price; }));
      return '<button type="button" class="BDPick__Card' + (sel ? ' is-current' : '') + '" data-bd-pick-product="' + p.id + '" style="--i:' + i + '"' +
        ' aria-pressed="' + sel + '"' + (avail ? '' : ' disabled') + '>' +
        '<span class="BDPick__CardMedia">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" decoding="async">' : '') +
        '<span class="BDPick__CardTick" aria-hidden="true">' + ICON_TICK + '</span></span>' +
        '<span class="BDPick__CardName">' + esc(p.title) + '</span>' +
        '<span class="BDPick__CardPrice">' + (avail ? money(price) : 'Sold out') + '</span></button>';
    }).join('');
  }
  function renderSizes() {
    var p = merchOf(pk.box)[pk.pid], cur = slotState(pk.box)[pk.slot], r = pk.root;
    r.querySelector('[data-bd-pick-dimg]').src = p.img || '';
    r.querySelector('[data-bd-pick-dtitle]').textContent = p.title;
    r.querySelector('[data-bd-pick-dprice]').textContent = money(p.price);
    r.querySelector('[data-bd-pick-dlegend]').textContent = p.opt;
    pk.vid = cur.pid === p.id ? cur.vid : 0;
    r.querySelector('[data-bd-pick-pills]').innerHTML = p.variants.map(function (v, i) {
      return '<button type="button" class="BDPick__Pill" data-bd-pick-variant="' + v.id + '" style="--i:' + i + '" aria-pressed="' + (v.id === pk.vid) + '"' + (v.available ? '' : ' disabled') + '>' + esc(v.title) + '</button>';
    }).join('');
    syncConfirm();
  }
  function syncConfirm() {
    var p = merchOf(pk.box)[pk.pid], v = variantOf(p, pk.vid), btn = pk.root.querySelector('[data-bd-pick-confirm]');
    btn.disabled = !v;
    btn.textContent = v ? 'Choose ' + p.title + ', ' + v.title : 'Choose a ' + (p.opt || 'size').toLowerCase();
  }
  function setPage(n, instant) {
    var r = pk.root, stage = r.querySelector('.BDPick__Stage');
    var from = stage.getBoundingClientRect().height;
    pk.page = n; stage.setAttribute('data-page', String(n));
    /* the stage eases to the active page's own height (it lives in an overlay, so nothing on the page moves) */
    var to = r.querySelector('[data-bd-page="' + n + '"]').offsetHeight + 12;
    if (instant || reduced || !from) { stage.style.transition = 'none'; stage.style.height = to + 'px'; stage.getBoundingClientRect(); stage.style.transition = ''; }
    else { stage.style.height = from + 'px'; stage.getBoundingClientRect(); stage.style.height = to + 'px'; }
    r.querySelector('[data-bd-page="1"]').inert = n !== 1;
    r.querySelector('[data-bd-page="2"]').inert = n !== 2;
    r.querySelector('[data-bd-pick-back]').classList.toggle('is-shown', n === 2);
    r.querySelector('.BDPick__Title').textContent = n === 1 ? 'Choose item ' + (pk.slot + 1) : 'Pick your ' + (merchOf(pk.box)[pk.pid].opt || 'size').toLowerCase();
    r.querySelector('[data-bd-pick-sub]').textContent = n === 1 ? 'Any merch works. The cheaper of your two is free.' : merchOf(pk.box)[pk.pid].title + ' for item ' + (pk.slot + 1);
    setTimeout(function () {
      var f = n === 1 ? (r.querySelector('.BDPick__Card[aria-pressed="true"]') || r.querySelector('.BDPick__Card:not([disabled])'))
                      : (r.querySelector('.BDPick__Pill[aria-pressed="true"]') || r.querySelector('.BDPick__Pill:not([disabled])'));
      if (f) f.focus({ preventScroll: true });
    }, reduced ? 0 : 260);
  }
  var lockPad = '';
  function lockScroll(on) {
    var h = document.documentElement, b = document.body;
    if (on) { var sbw = window.innerWidth - h.clientWidth; lockPad = b.style.paddingRight; if (sbw > 0) b.style.paddingRight = sbw + 'px'; h.classList.add('bd-pick-lock'); }
    else { h.classList.remove('bd-pick-lock'); b.style.paddingRight = lockPad; }
  }
  function openPick(box, slot, trigger) {
    clearTimeout(pk.closing);
    var r = pickRoot();
    pk.box = box; pk.slot = slot; pk.trigger = trigger;
    var cur = slotState(box)[slot]; pk.pid = cur.pid; pk.vid = cur.vid;
    renderGrid();
    r.classList.remove('is-open', 'is-leaving');
    r.hidden = false; lockScroll(true);
    setPage(1, true);
    r.getBoundingClientRect();              /* styles resolved in the closed state, so this transitions without rAF */
    r.classList.add('is-open');
  }
  function closePick(restore) {
    var r = pk.root; if (!r || r.hidden) return;
    r.classList.remove('is-open'); r.classList.add('is-leaving');
    lockScroll(false);
    pk.closing = setTimeout(function () {
      r.hidden = true; r.classList.remove('is-leaving');
      if (restore !== false && pk.trigger && pk.trigger.isConnected) pk.trigger.focus({ preventScroll: true });
    }, reduced ? 0 : 320);
  }
  function commitPick(pid, vid) {
    var box = pk.box, s = slotState(box)[pk.slot];
    s.pid = pid; s.vid = vid;
    var trigger = pk.trigger;
    closePick();
    setTimeout(function () { paintSlot(box, pk.slot, true); bogoPaint(box); }, reduced ? 0 : 140);
    return trigger;
  }
  document.addEventListener('click', function (e) {
    var C = e.target.closest ? function (s) { return e.target.closest(s); } : function () { return null; };
    /* size menu first: an option pick, the pill toggle, or an outside click that closes it */
    var opt = C('[data-bd-size-vid]');
    if (opt) {
      if (opt.disabled) return;
      var sEl = opt.closest('[data-bd-slot]'), sBox = sEl.closest('[data-bd-bogo]'), si = Number(sEl.getAttribute('data-bd-slot'));
      slotState(sBox)[si].vid = Number(opt.getAttribute('data-bd-size-vid'));
      sizeClose(false);
      paintSlot(sBox, si, true); bogoPaint(sBox);
      var back = sEl.querySelector('[data-bd-size-btn]'); if (back) back.focus({ preventScroll: true });
      return;
    }
    var sbtn = C('[data-bd-size-btn]');
    if (sbtn) { var wrap = sbtn.parentNode; if (sz.open === wrap) sizeClose(true); else sizeOpen(wrap); return; }
    if (sz.open && !sz.open.contains(e.target)) sizeClose(false);
    var open = C('[data-bd-slot-open]');
    if (open) { var slot = open.closest('[data-bd-slot]'), box = slot.closest('[data-bd-bogo]'); merchOf(box); openPick(box, Number(slot.getAttribute('data-bd-slot')), open); return; }
    if (!pk.root || pk.root.hidden || !pk.root.contains(e.target)) return;
    if (e.target.closest('[data-bd-pick-close]')) { closePick(); return; }
    if (e.target.closest('[data-bd-pick-back]')) { setPage(1); return; }
    var card = e.target.closest('[data-bd-pick-product]');
    if (card && !card.disabled) {
      var p = merchOf(pk.box)[Number(card.getAttribute('data-bd-pick-product'))];
      pk.root.querySelectorAll('.BDPick__Card').forEach(function (c) { c.setAttribute('aria-pressed', String(c === card)); });
      pk.pid = p.id;
      if (!p.sized) {                                   /* one size: pick instantly, tick, close */
        card.classList.add('is-chosen');
        var only = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
        setTimeout(function () { commitPick(p.id, only.id); }, reduced ? 0 : 280);
        return;
      }
      renderSizes(); setPage(2); return;
    }
    var pill = e.target.closest('[data-bd-pick-variant]');
    if (pill && !pill.disabled) {
      pk.vid = Number(pill.getAttribute('data-bd-pick-variant'));
      pk.root.querySelectorAll('.BDPick__Pill').forEach(function (b) { b.setAttribute('aria-pressed', String(b === pill)); });
      syncConfirm(); return;
    }
    if (e.target.closest('[data-bd-pick-confirm]') && pk.vid) {
      var cf = e.target.closest('[data-bd-pick-confirm]');
      cf.classList.add('is-done'); cf.innerHTML = ICON_TICK + '<span>Done</span>';
      setTimeout(function () { commitPick(pk.pid, pk.vid); }, reduced ? 0 : 240);
    }
  });
  document.addEventListener('keydown', function (e) {
    if (sz.open) {
      if (e.key === 'Escape') { e.preventDefault(); sizeClose(true); return; }
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        var opts = Array.prototype.filter.call(sz.open.querySelectorAll('[data-bd-size-vid]'), function (b) { return !b.disabled; });
        var at = opts.indexOf(document.activeElement), n = opts.length;
        if (n) opts[(at + (e.key === 'ArrowDown' ? 1 : -1) + n) % n].focus({ preventScroll: true });
        return;
      }
      if (e.key === 'Tab') { sizeClose(false); }
      return;
    }
    var r = pk.root; if (!r || r.hidden) return;
    if (e.key === 'Escape') { e.preventDefault(); if (pk.page === 2) setPage(1); else closePick(); return; }
    if (e.key !== 'Tab') return;
    var f = Array.prototype.filter.call(r.querySelectorAll('.BDPick__Panel button:not([disabled])'), function (b) { return b.offsetParent !== null && !b.closest('[inert]'); });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------------- add to cart ---------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.ProductForm__AddToCart'); if (!btn) return;
    var form = btn.closest('form'), box = form && form.querySelector('[data-bd-bogo]'); if (!box) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (btn.getAttribute('aria-busy') === 'true') return;
    var status = box.querySelector('[data-bd-bogo-status]'), items = bogoItems(box);
    var M = merchOf(box), short = items.filter(function (it) {
      for (var k in M) { var v = variantOf(M[k], it.id); if (v) return v.q != null && it.quantity > v.q; }
      return false;
    })[0];
    if (short) {
      var sv; for (var k2 in M) { sv = sv || variantOf(M[k2], short.id); }
      status.textContent = 'Only ' + sv.q + ' left in that size. Choose a different size for one of the items.';
      return;
    }
    var qty = items.reduce(function (a, i) { return a + i.quantity; }, 0);
    status.textContent = ''; btn.setAttribute('aria-busy', 'true');
    document.dispatchEvent(new CustomEvent('theme:loading:start'));
    post('/cart/add.js', { items: items }).then(function () {
      form.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: { variant: { id: items[0].id }, quantity: qty } }));
    }).catch(function (err) {
      status.textContent = (err && err.data && err.data.description) || 'That couldn’t be added. Please try again.';
    }).then(function () { btn.removeAttribute('aria-busy'); document.dispatchEvent(new CustomEvent('theme:loading:end')); });
  }, true);

  /* ================================ wiring ================================ */
  function afterRender() { playRace(); paintCodeMsg(); syncGift(); }
  function boot() {
    bogoInit(document); syncGift();
    var drawer = document.getElementById('sidebar-cart');
    if (drawer) new MutationObserver(function (list) {
      var rerendered = false, opened = false;
      list.forEach(function (m) {
        if (m.type === 'childList') rerendered = true;
        if (m.type === 'attributes' && drawer.getAttribute('aria-hidden') === 'false') opened = true;
      });
      if (rerendered) { clearTimeout(drawer._bdT); drawer._bdT = setTimeout(afterRender, 80); }
      if (opened) { var bar = drawer.querySelector('[data-bd-race]'); if (bar) { bar._bdPlayed = false; bar._bdPending = false; } setTimeout(playRace, 180); }
    }).observe(drawer, { childList: true, attributes: true, attributeFilter: ['aria-hidden'] });
    /* cart page: Prestige swaps the .Cart form inside its parent, so watch that parent only (no subtree, no self-trigger) */
    var pageForm = document.querySelector('#shopify-section-cart-template .Cart');
    var page = pageForm && pageForm.parentNode;
    if (page) new MutationObserver(function () { clearTimeout(page._bdT); page._bdT = setTimeout(afterRender, 80); }).observe(page, { childList: true });
  }
  document.addEventListener('product:added', function () { setTimeout(syncGift, 400); });
  document.addEventListener('shopify:section:load', function (e) { bogoInit(e.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
